import { Component, Input, Output, EventEmitter, OnInit, ElementRef, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { OptiData } from '../../../_models/opti_data';
import { OptiPiece } from '../../../_models/opti_piece';
import { Easel } from '../../../_models/easel';
import { OptiFunction } from '../../../_helpers/opti.function';

import { DbTransform } from '../../../_helpers/db.transform';
import { OptiService } from '../../opti.service';

import * as fromSortableColumn from '../../../sortableColumn/sortableColumn.function';

import { Globals } from '../../../_globals/globals';
import { BendingMachineService } from '../../../maestros/bending_machine/bending_machine.service';
import { FileService } from '../../../file/file.service';

@Component({
  selector: 'app-prod',
  templateUrl: './opti-prod.component.html'
})

export class OptiProdComponent implements OnInit, OnChanges {

  dbt: DbTransform;
  
  opti: OptiFunction;

  title: string;
  subtitle: string;

  divideModal: boolean;
  divideModalResult: boolean;
  lotFinderModal: boolean;
  helpModal: boolean;
  helpSection: string;
  tourModal: boolean;
  tourIndex: number;
  compactAssocModal: boolean;
  compactAssocLoading: boolean;
  compactAssocLot: number;
  compactAssocMode: string;
  compactAssocOptions: any[];
  pendingPrintInfo: any;
  pendingPrintUseTmp: boolean;

  searchOptiForm: FormGroup;
  searchPieceForm: FormGroup;
  
  itemsPerPage: number;
  currentPage: number;
  piecesItemsPerPage: number;
  piecesCurrentPage: number;
  
  fromDate: Date;
  toDate: Date;

  sub: any;
  // paramNum: number;
  paramRefresh: string;

  setTimeout_aux: number;
  
  actionInfo: string;
  alertInfo: string;
  infoInfo: string;
  lotStudyWarning: string;

  // Id del usuario actual logueado.
  current_user_id: number;
  current_group_id: number;
  current_username: string;
  current_enviroment: string;
  
  button_virtual_pressed: boolean;
  button_study_pressed: boolean;
  
  sequence_list: any[];
  sequence_list_ordered: any[];
  lot_progress_list: any[];
  lot_progress_list_ordered: any[];
  
  divide_sequence: any;
  current_lot: number;
  last_divide_request: any;
  last_divide_info: any;
  print_mode: string;
  print_include_grouped_profiles: boolean;
  selected_dispatch_easel_id: number;
  selected_compact_easel_id: number;
  detected_origin_lot: number;
  pending_compact_lots: number[];
  current_compact_lot: number;
  lotFinderPattern: string;
  lotFinderRows: any[];
  lotFinderError: string;
  lotFinderLoading: boolean;
  lotFinderDateFrom: string;
  lotFinderDateTo: string;
  autoOptiStatusKnown: boolean;
  hasAutoOptiData: boolean;
  bendingMachineList: any[];
  selected_bending_machine_id: number;
  bendingCodesModal: boolean;
  bendingCodesMissingRows: any[];
  bendingCodesLotList: number[];
  bendingCodesUseTmp: boolean;

  @ViewChild('searchButton',  {static: true}) searchButton: ElementRef;
  @ViewChild('lotFinderInput',  {static: false}) lotFinderInput: ElementRef;

  @Input() optiList: OptiData[];
  @Input() compactList: any;
  @Input() lotStudy: any;
  @Input() divideLotList: any;
  @Input() retalList: OptiPiece[];
  @Input() currentOpti: OptiData;
  @Input() easelList: Easel[];
  @Input() filterFields: any[];
  @Output() searchOpti = new EventEmitter<any[]>();
  @Output() divideLot: any = new EventEmitter<any>();
  @Output() deleteOpti = new EventEmitter<OptiData>();
  @Output() updateRetalList: any = new EventEmitter<{opti_id: number}>();
  @Output() chargeOpti: any = new EventEmitter<{opti_id: number}>();
  @Output() makeLotStudy = new EventEmitter<any>();
  @Output() printDivideLot = new EventEmitter<any>();
  @Output() compactOpti = new EventEmitter<any>();
  @Output() printCompactOpti = new EventEmitter<any>();
  @Output() reloadEaselList = new EventEmitter<void>();
  @Output() showInfoModal = new EventEmitter<{ value: boolean, info: string, link: string, skin: string }>();
  @Output() changingLoading = new EventEmitter<boolean>();
  @Output() changingLoading2 = new EventEmitter<boolean>();
  
  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private globals: Globals,
    private optiService: OptiService,
    private bendingMachineService: BendingMachineService,
    private fileService: FileService
  ) {}

  ngOnInit() {

    this.sub = this.route.params.subscribe(params => {
      // this.paramNum = +params['num']; // Importante el '+' para obtener números
      this.paramRefresh = params['rf'];
    });

    this.dbt = new DbTransform(localStorage.getItem('enviroment')); //this.globals.currentUserEnviroment);
	this.opti = new OptiFunction();
	
    this.setTimeout_aux = 3000;

    this.title = 'Productividad+';
    this.subtitle = 'Lote';
    this.lotStudyWarning = '';
    this.bendingMachineList = [];
    this.selected_bending_machine_id = null;
    this.bendingCodesModal = false;
    this.bendingCodesMissingRows = [];
    this.bendingCodesLotList = [];
    this.bendingCodesUseTmp = false;

    this.divideModal = false;
    this.divideModalResult = false;
    this.lotFinderModal = false;
    this.helpModal = false;
    this.helpSection = 'overview';
    this.tourModal = false;
    this.tourIndex = 0;
    this.compactAssocModal = false;
    this.compactAssocLoading = false;
    this.compactAssocLot = null;
    this.compactAssocMode = 'no';
    this.compactAssocOptions = [];
    this.pendingPrintInfo = null;
    this.pendingPrintUseTmp = false;

    this.current_user_id = Number(localStorage.getItem('user_id'));
    this.current_group_id = Number(localStorage.getItem('group_id'));
    this.current_username = localStorage.getItem('username');
    this.current_enviroment = localStorage.getItem('enviroment');

    if (this.current_username !== null && this.current_username !== undefined) {
      this.current_username = this.current_username.split('@')[0];
    }

    console.log('->->< Usuario actual logueado: ' + this.current_user_id + ' ;group_id = ' + this.current_group_id);
    console.log(this.current_username);

    console.log('--> -> FilterFields:');
    console.log(this.filterFields);
    
    // Por defecto la fecha de inicio para la búsqueda será de 15 días atrás.
    let subtract_days = 15;
    
    // Declaración de variables para el control de rango de fechas.
    this.fromDate = new Date();

    // NOTA: Colocamos la fecha inicial de búsqueda unos cuantos días atrás
    // dependiendo del perfil del usuario que esté logueado.
    this.fromDate.setDate(this.fromDate.getDate() - subtract_days);

    this.toDate = new Date();

    // this.toDate.setMinutes(this.toDate.getMinutes() + (13 * 60));

    if (this.filterFields['f_date'] === undefined || this.filterFields['f_date'] === null) {
      this.filterFields['f_date'] = this.fromDate;
    }

    if (this.filterFields['f_date2'] === undefined || this.filterFields['f_date2'] === null) {
      this.filterFields['f_date2'] = this.toDate;
    }

    this.searchOptiForm = this.formBuilder.group({
      lot_study: this.filterFields['lot_study'],
      lot_divide: this.filterFields['lot_divide']
    });
    
    this.searchOptiForm.controls.lot_divide.setValue(50);
        
    this.searchPieceForm = this.formBuilder.group({
	  f_broke:  this.filterFields['f_broke'],
	  f_finished: this.filterFields['f_finished'],
	  f_batchno: this.filterFields['f_batchno'],
	  f_barcode: this.filterFields['f_barcode'],
      f_mat: this.filterFields['f_mat'],
      f_width: this.filterFields['f_width'],
      f_height: this.filterFields['f_height'],
      offset: this.piecesCurrentPage,
      pagesize: this.piecesItemsPerPage
    });
    
    // Número de elementos por página de las tablas.
    this.itemsPerPage = 10;
    this.piecesItemsPerPage = 8;
    // Pagina inicial de las tablas.
    this.currentPage = 1;
    this.piecesCurrentPage = 1;
    
    // El botón de compactación no ha sido pulsado.
    this.button_virtual_pressed = false;
    
    this.button_study_pressed = false;

    // Cargamos inicialmente la lista de inventario si el parámetro de refresco lo indica.
    // if (this.paramRefresh === 'true') {
    //   this.buttonLotStudy();
    // }
    
    this.sequence_list = [];
    this.sequence_list_ordered = [];
    this.lot_progress_list = [];
    this.lot_progress_list_ordered = [];
    
    this.divide_sequence = null;
    this.current_lot = null;
    this.last_divide_request = null;
    this.last_divide_info = null;
    this.print_mode = 'basic';
    this.print_include_grouped_profiles = true;
    this.selected_dispatch_easel_id = null;
    this.selected_compact_easel_id = null;
    this.detected_origin_lot = null;
    this.pending_compact_lots = [];
    this.current_compact_lot = null;
    this.lotFinderPattern = '';
    this.lotFinderRows = [];
    this.lotFinderError = '';
    this.lotFinderLoading = false;
    this.autoOptiStatusKnown = false;
    this.hasAutoOptiData = false;
    this.loadBendingMachines();
    this.initLotFinderDateRange();

    // Colocamos inicialmente el foco en el botón de búsqueda.
    this.searchButton.nativeElement.focus();

  } // End function OnInit

  ngOnChanges(changes: SimpleChanges) {

    console.log('->-> Entrando en ngOnChanges: ');
    // console.log(changes);

    if (changes.easelList !== undefined) {
      const preferredEaselId = this.getPreferredEaselId(changes.easelList.currentValue);
      if ((this.selected_dispatch_easel_id === null || this.selected_dispatch_easel_id === undefined) && preferredEaselId !== null) {
        this.selected_dispatch_easel_id = preferredEaselId;
      }
      if ((this.selected_compact_easel_id === null || this.selected_compact_easel_id === undefined) && preferredEaselId !== null) {
        this.selected_compact_easel_id = preferredEaselId;
      }
    }

    if (changes.compactList !== undefined) {
      if (changes.compactList.currentValue &&
          changes.compactList.currentValue.order_opti &&
          changes.compactList.currentValue.total_virtual &&
          changes.compactList.currentValue.order_opti.length > 0 &&
          changes.compactList.currentValue.total_virtual.length > 0 &&
          this.button_virtual_pressed) {
        this.printCompactPile(changes.compactList.currentValue);
        this.requestNextCompactLot();
      } else if (this.button_virtual_pressed) {
        const lotLabel = this.current_compact_lot ? this.current_compact_lot : this.current_lot;
        this.alertInfo = 'No hay optimizaciones registradas para el lote ' + lotLabel + '. No se puede generar la lista de compactación.';
        this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
        this.requestNextCompactLot();
      }
    }
    
	if (changes.lotStudy !== undefined) {
		
		console.log('--> ngOnChanges changes.lotStudy.currentValue:');
      	// console.log(changes.lotStudy.currentValue);

        if (this.button_study_pressed) {
          const lotStudyData = changes.lotStudy.currentValue;

          if (lotStudyData &&
              lotStudyData.sequence_list &&
              lotStudyData.lot_progress_list &&
              lotStudyData.lot) {
            this.autoOptiStatusKnown = lotStudyData.has_auto_opti !== undefined && lotStudyData.has_auto_opti !== null;
            this.hasAutoOptiData = this.autoOptiStatusKnown ? (lotStudyData.has_auto_opti === true) : false;
            this.showLotStudy(lotStudyData);
          } else if (lotStudyData && lotStudyData.lot) {
            this.autoOptiStatusKnown = lotStudyData.has_auto_opti !== undefined && lotStudyData.has_auto_opti !== null;
            this.hasAutoOptiData = this.autoOptiStatusKnown ? (lotStudyData.has_auto_opti === true) : false;
            this.lot_progress_list = [];
            this.lot_progress_list_ordered = [];
            this.detected_origin_lot = lotStudyData.origin_lot ? Number(lotStudyData.origin_lot) : null;
            this.lotStudyWarning = lotStudyData.issue_message
              ? lotStudyData.issue_message
              : ('No hay datos de progreso para el lote ' + lotStudyData.lot + '. Revisa que la vista de progreso esté actualizada.');
            this.button_study_pressed = false;
          }
        }
		
	} // End changes.lotStudy.
	
		if (changes.divideLotList !== undefined) {
		
		console.log('--> ngOnChanges changes.divideLotList.currentValue:');
      	// console.log(changes.divideLotList.currentValue);
		
			if (changes.divideLotList.currentValue && 
      		changes.divideLotList.currentValue.lot_1 &&
      		changes.divideLotList.currentValue.lot_2) {

        const divideResult = changes.divideLotList.currentValue;
        const minSeq = this.last_divide_request ? this.last_divide_request.min_seq : 1;
        const splitSeq = this.last_divide_request ? this.last_divide_request.split_seq : null;
        const maxSeq = this.last_divide_request ? this.last_divide_request.max_seq : null;
        const divisionType = this.last_divide_request ? this.last_divide_request.division_type : null;

        this.last_divide_info = {
          lot_0: divideResult.lot_0,
          lot_1: divideResult.lot_1,
          lot_2: divideResult.lot_2,
          min_seq: minSeq,
          split_seq: splitSeq,
          max_seq: maxSeq,
          division_type: divisionType
        };

				// Ventana que muestra el resultado de la división del lote.
				this.showDivideModalResult(true);
			}
		
	} // End changes.lotStudy.

  } // End function ngOnChanges

  // convenience getter for easy access to form fields
  get f() { return this.searchOptiForm.controls; }

  // ---------------------------------------
  //          Funciones Asíncronas
  // ---------------------------------------

  async emitDivideLot(lotIn) {

    console.log('->> Entrando en emitDivideLot...');

    let promise_in = new Promise((resolve, reject) => {
      console.log('->> Inicio Promesa de emitDivideLot:');
      const add  = this.divideLot.emit(lotIn);
      console.log('->> Final Promesa de emitDivideLot:');
      resolve(add);
    });

    return promise_in.then((response) => {
      console.log('->> Respuesta de emitDivideLot:');
      console.log(response);
      
    }).catch((error) => {
      console.log('->> Error en emitDivideLot:');
      console.log(error);
    });

  } // End function emitDivideLot
  
  async emitUpdateRetalList(optiIn, groupConsultIn) {

    console.log('->> Entrando en emitUpdateRetalList...');

    let promise_in = new Promise((resolve, reject) => {
      console.log('->> Inicio Promesa de emitUpdateRetalList:');
      const add = this.updateRetalList.emit({opti_id: optiIn['id']});
      console.log('->> Final Promesa de emitUpdateRetalList:');
      resolve(add);
    });

    return promise_in.then((response) => {
      console.log('->> Respuesta de emitUpdateLagerList:');
      console.log(response);
    }).catch((error) => {
      console.log('->> Error en emitUpdateLagerList:');
      console.log(error);
    });

  } // End function emitUpdateRetalList
  
  async emitChargeOpti(optiIn, groupConsultIn) {

    console.log('->> Entrando en emitChargeOpti...');

    let promise_in = new Promise((resolve, reject) => {
      console.log('->> Inicio Promesa de emitChargeOpti:');
      const add = this.chargeOpti.emit({opti_id: optiIn['id']});
      console.log('->> Final Promesa de emitChargeOpti:');
      resolve(add);
    });

    return promise_in.then((response) => {
      console.log('->> Respuesta de emitChargeOpti:');
      console.log(response);
    }).catch((error) => {
      console.log('->> Error en emitChargeOpti:');
      console.log(error);
    });

  } // End function emitChargeOpti

  // Función que se ejecuta cuando se pulsa el botón "Consumir" para pasar a la sección de "OptiConsume".
  async buttonDivideLot(lotIn: any | null, divisionTypeIn: number) {
    console.log('-> -> buttonDivideLot presionado:');
    console.log(lotIn);
    
    this.divide_sequence = lotIn;
    this.divide_sequence.porcentaje_acumulado = Number(this.divide_sequence.porcentaje_acumulado);
    this.divide_sequence['division_type'] = divisionTypeIn;
    
    this.showDivideModal(true);

    // Una vez se tengan los datos actualizados para poder cargar bien
    // la siguiente sección, se hace el redireccionamiento hacia la misama.
    // setTimeout(() => {this.router.navigate(['/file-list', 'charge']); }, this.setTimeout_aux);

  } // End function buttonChargeOpti

  // ---------------------------------------
  //        FIN Funciones Asíncronas
  // ---------------------------------------
  
  showDivideModal(value: boolean) {
    this.divideModal = value;

  } // End function showDivideModal
  
  showDivideModalResult(value: boolean) {
    this.divideModalResult = value;

  } // End function showDivideModalResult

  showLotFinderModal(value: boolean) {
    this.lotFinderModal = value;
    if (!value) {
      this.lotFinderLoading = false;
      this.lotFinderError = '';
      return;
    }
    if (!this.lotFinderDateFrom || !this.lotFinderDateTo) {
      this.initLotFinderDateRange();
    }
    this.lotFinderError = '';
    this.lotFinderRows = [];
    setTimeout(() => {
      if (this.lotFinderInput && this.lotFinderInput.nativeElement) {
        this.lotFinderInput.nativeElement.focus();
      }
    }, 0);
  }

  showHelpModal(value: boolean) {
    this.helpModal = value;
    if (value) {
      this.helpSection = 'overview';
    }
  }

  setHelpSection(sectionIn: string) {
    if (!sectionIn) {
      return;
    }
    this.helpSection = sectionIn;
  }

  isHelpSection(sectionIn: string): boolean {
    return this.helpSection === sectionIn;
  }

  getTourSteps(): Array<{title: string, body: string, targetId: string}> {
    const hasCurrent = !!(this.lot_progress_list && this.lot_progress_list.length > 0);
    const hasSuggested = !!(this.lot_progress_list_ordered && this.lot_progress_list_ordered.length > 0);

    if (!hasCurrent) {
      return [
        {
          title: '1) Estudio del lote',
          body: 'Introduce lote y ejecuta Estudiar Productividad+ para cargar las tablas de análisis.',
          targetId: 'prod-tour-study'
        },
        {
          title: '2) Flujo completo',
          body: 'Con datos cargados podrás imprimir Producción, Rutas Expedición y Compactación (LCE/LCH/LCH+), eligiendo caballete y modo de asociación PV en Producción.',
          targetId: 'prod-tour-study'
        }
      ];
    }

    const steps: Array<{title: string, body: string, targetId: string}> = [
      {
        title: '1) Estudio del lote',
        body: 'Introduce lote y ejecuta Estudiar Productividad+ para cargar tablas de análisis.',
        targetId: 'prod-tour-study'
      },
      {
        title: '2) Orden actual',
        body: 'Revisa secuencias, unidades, kilos y tiempos acumulados del flujo real.',
        targetId: 'prod-tour-current'
      },
      {
        title: hasSuggested ? '4) División de lote' : '3) División de lote',
        body: 'Usa Dividir cuando detectes un punto de ruptura operativo en secuencia o carga.',
        targetId: 'prod-tour-divide'
      },
      {
        title: hasSuggested ? '5) Impresión operativa' : '4) Impresión operativa',
        body: 'Selecciona listado (Producción, Rutas, Compactación LCE/LCH/LCH+), elige caballete y, en Producción, asocia compactación para completar PV.',
        targetId: 'prod-tour-print'
      }
    ];

    if (hasSuggested) {
      steps.splice(2, 0, {
        title: '3) Orden sugerido',
        body: 'Compara con la alternativa propuesta para mejorar corte y continuidad de proceso.',
        targetId: 'prod-tour-suggested'
      });
    }

    return steps;
  }

  getCurrentTourStep(): {title: string, body: string, targetId: string} {
    const steps = this.getTourSteps();
    if (!steps || steps.length === 0) {
      return { title: '', body: '', targetId: '' };
    }
    const index = Math.max(0, Math.min(this.tourIndex, steps.length - 1));
    return steps[index];
  }

  startTour() {
    this.helpModal = false;
    this.tourIndex = 0;
    this.tourModal = true;
    this.focusTourTarget();
  }

  closeTour() {
    this.tourModal = false;
  }

  nextTourStep() {
    const steps = this.getTourSteps();
    if (this.tourIndex < (steps.length - 1)) {
      this.tourIndex++;
      this.focusTourTarget();
      return;
    }
    this.closeTour();
  }

  prevTourStep() {
    if (this.tourIndex > 0) {
      this.tourIndex--;
      this.focusTourTarget();
    }
  }

  private focusTourTarget() {
    const step = this.getCurrentTourStep();
    const targetId = step && step.targetId ? step.targetId : '';
    if (!targetId) {
      return;
    }

    setTimeout(() => {
      const element = document.getElementById(targetId);
      if (!element) {
        return;
      }

      try {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (error) {
        element.scrollIntoView();
      }

      const previousOutline = (element as HTMLElement).style.outline;
      const previousOffset = (element as HTMLElement).style.outlineOffset;
      (element as HTMLElement).style.outline = '3px solid #3298dc';
      (element as HTMLElement).style.outlineOffset = '4px';
      setTimeout(() => {
        (element as HTMLElement).style.outline = previousOutline;
        (element as HTMLElement).style.outlineOffset = previousOffset;
      }, 900);
    }, 80);
  }

  searchLotRelations() {
    this.lotFinderError = '';
    this.lotFinderRows = [];

    const pattern = this.lotFinderPattern ? this.lotFinderPattern.toString().trim() : '';
    if (pattern === '') {
      this.lotFinderError = 'Indique al menos algunos dígitos para buscar.';
      return;
    }

    if (!this.lotFinderDateFrom || !this.lotFinderDateTo) {
      this.lotFinderError = 'Indique un rango de fechas válido.';
      return;
    }

    this.lotFinderLoading = true;

    this.optiService.lotRelations({
      pattern: pattern,
      date_from: this.lotFinderDateFrom,
      date_to: this.lotFinderDateTo
    }).subscribe(
      (data: any) => {
        this.lotFinderLoading = false;
        if (data && Array.isArray(data.rows)) {
          this.lotFinderRows = data.rows;
        } else {
          this.lotFinderRows = [];
        }
        if (this.lotFinderRows.length < 1) {
          this.lotFinderError = 'No se encontraron lotes padre/hijo para ese patrón.';
        }
      },
      (error) => {
        this.lotFinderLoading = false;
        this.lotFinderRows = [];
        this.lotFinderError = 'No se pudo realizar la búsqueda.';
      }
    );
  }

  onLotFinderKeydown(event: any) {
    if (!event) return;
    if (event.key === 'Enter') {
      event.preventDefault();
      this.searchLotRelations();
    }
  }

  useLotFromFinder(lotIn: any, event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const lot = Number(lotIn);
    if (!lot || isNaN(lot)) return;

    this.searchOptiForm.controls.lot_study.setValue(String(lot));
    this.showLotFinderModal(false);
    this.buttonLotStudy();
  }

  private initLotFinderDateRange() {
    const today = new Date();
    const from = new Date();
    from.setDate(today.getDate() - 30);
    this.lotFinderDateFrom = this.formatDateInput(from);
    this.lotFinderDateTo = this.formatDateInput(today);
  }

  private formatDateInput(dateIn: Date): string {
    const y = dateIn.getFullYear();
    const m = ('0' + (dateIn.getMonth() + 1)).slice(-2);
    const d = ('0' + dateIn.getDate()).slice(-2);
    return y + '-' + m + '-' + d;
  }
  
  async confirmDivideLot() {
	console.log('->> confirmDivideLot => ');
	console.log(this.divide_sequence);
	
    // tslint:disable-next-line:only-arrow-functions
    /*
    const dataEmitDivideLot = await this.emitDivideLot(this.divide_sequence).then(async function(data) {

      console.log('->> confirmDivideLot emitDivideLot data => ');
      console.log(data);
      
      return data;
    }); // */
    
    const minSeqBase = this.lot_progress_list.length > 0 ? Number(this.lot_progress_list[0].seq_inicio) : 1;
    const maxSeqBase = this.lot_progress_list.length > 0
      ? Number(this.lot_progress_list[this.lot_progress_list.length - 1].seq_fin)
      : Number(this.divide_sequence.seq_fin);

    this.last_divide_request = {
      split_seq: Number(this.divide_sequence.seq_fin),
      min_seq: minSeqBase,
      max_seq: maxSeqBase,
      division_type: Number(this.divide_sequence.division_type)
    };

    await this.divideLot.emit({divide_sequence: this.divide_sequence, order_material: this.lot_progress_list_ordered});
    
    this.showDivideModal(false);
  } // End function confirmDivideLot.

  // Función que filtra de un array los valores que no sean superiores a cero de un campo dado.
  filterZeroItems(listIn: [], fieldIn: string) {
    return listIn.filter(x => x[fieldIn] > 0);
  } // End function filterZeroItems

  // --------- Detectar tecla presionada
  onKeydown(event: any) {
    // console.log('Presionada tecla...');
    // console.log(event);
    if (event.key === 'Enter') {
      event.preventDefault();
      // console.log('--> Tecla ENTER.');

      this.buttonLotStudy();
    }
  } // End function onKeydown

  // Función que ordena el listado de elementos.
  onSorted(event: any) {
    console.log('--> onSorted Tabla directiva lanzada:');
    console.log(event);

    // console.log(' -> Columna a ordenar: ' + event.sortColumn);
    // console.log(' -> Dirección orden: ' + event.sortDirection);
    // console.log(' -> Es número: ' + event.isNumeric);

    // Si hubiese que realizar alguna acción específica para la columna seleccionada.
    // switch (event.sortColumn) {
    //   case 'mat_desc':
    //     break;

    //   case 'lagm_platz':
    //     break;
    // }

    // Se lanza la función de ordenación del array de inventario.
    // Modifica directamente el array pasado como primer parámetro.
    // NOTA: el nombre de la columna, al ser para ORACLE, tendrá que estar en mayúsculas.
    this.lot_progress_list = fromSortableColumn.sortByColumn(
    this.lot_progress_list, this.dbt.t(event.sortColumn), event.sortDirection, event.isNumeric);

    console.log('--> Array después de la ordenación:');
    console.log(this.lot_progress_list);

  } // End function onSorted
  
  // Función que obtiene el primer elemento de un array JSON pasado como cadena.
  getProductId(value) {
	return JSON.parse(value)[0];
  }
  
  // Función que lanza los procesos para realizar el estudio de productividad de un lote.
  async buttonLotStudy(event?: Event) {
	
		console.log('Pulsado botón buttonLotStudy:');
		this.lotStudyWarning = '';
    this.detected_origin_lot = null;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // Evita lanzar varias peticiones simultáneas para el mismo lote.
    if (this.button_study_pressed) {
      return;
    }

    this.autoOptiStatusKnown = false;
    this.hasAutoOptiData = false;
	
	if (!this.searchOptiForm.controls.lot_study.value) {
		console.log('-> Hay que indicar al menos un número de lote en el campo "Lote" antes de pulsar el botón "Estudiar".');
		
		this.alertInfo = 'Hay que indicar al menos un número de lote en el campo "Lote" antes de pulsar el botón "Estudiar Productividad+". <br>';
		
		this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
		
		return;
	}
	
	// await this.changeChargeModal(true);

	let data = [];
	
	this.searchPieceForm.controls.f_batchno.setValue(this.searchOptiForm.controls.lot_study.value);
	
    const p = { ...data, ...this.searchPieceForm.value };
    
    this.button_study_pressed = true;
	
    this.makeLotStudy.emit(p);
    
    // await this.changeChargeModal(false);
	
  } // End function buttonLotStudy.

  buttonOpenAutoOpti(recoverIn: boolean) {
    const lot = this.getCurrentLotForAutoOpti();
    if (!lot) {
      return;
    }
    const urlTree = this.router.createUrlTree(['/auto-opti-lote'], {
      queryParams: {
        lot: lot,
        action: recoverIn ? 'recover' : 'start'
      }
    });
    const url = this.router.serializeUrl(urlTree);
    const hashUrl = (window.location && window.location.origin ? window.location.origin : '') + '/#' + url;
    window.open(hashUrl, '_blank');
  }

  private getCurrentLotForAutoOpti(): string {
    const lotValue = this.searchOptiForm && this.searchOptiForm.controls && this.searchOptiForm.controls.lot_study
      ? (this.searchOptiForm.controls.lot_study.value ? this.searchOptiForm.controls.lot_study.value.toString() : '')
      : '';
    const firstLot = lotValue
      .split(',')
      .map((item) => item.trim())
      .find((item) => /^[0-9]+$/.test(item));
    if (firstLot) {
      return firstLot;
    }
    if (this.current_lot && Number(this.current_lot) > 0) {
      return this.current_lot.toString();
    }
    return '';
  }
  
  // Función que se lanza cuando se reciben los datos de estudio de un lote.
  showLotStudy(lotStudyIn) {
	
	console.log('--> showLotStudy:');
    // console.log(lotStudyIn);
    
    // Se vacía la lista con el resultado sugerido, que se volverá a calcular aquí.
    this.lot_progress_list_ordered = [];
    this.last_divide_info = null;
    this.last_divide_request = null;
	    this.current_lot = lotStudyIn && lotStudyIn.lot ? Number(lotStudyIn.lot) : null;
      this.detected_origin_lot = lotStudyIn && lotStudyIn.origin_lot ? Number(lotStudyIn.origin_lot) : null;
    
    this.sequence_list = lotStudyIn.sequence_list;
    
    // Modo de ordenación por "tanto porciento progresado".
    // NOTA: No va a usarse porque esta ordenación mezcla materiales "fáciles"
    // de cortar con materiales "difíciles" de cortar.
    // this.sequence_list_ordered = JSON.parse(JSON.stringify(this.sequence_list));
    // this.sequence_list_ordered = this.opti.orderByLotProgress(this.sequence_list_ordered, true);
    
    // console.log('--> sequence_list_ordered:');
    // console.log(this.sequence_list_ordered);
    
	    this.lot_progress_list = lotStudyIn.lot_progress_list;
	    this.enrichProgressTimeInMinutes(this.lot_progress_list);
    
    console.log('--> lot_progress_list:');
    // console.log(this.lot_progress_list);
    
    let total_uds = 0;
    
    if (this.lot_progress_list.length) {
    	total_uds = this.lot_progress_list[this.lot_progress_list.length - 1].unidades_acumuladas;
    }
    
    console.log('--> total_uds:');
    console.log(total_uds);
    
    // Añadimos información extra de "unidades" y "porcentaje" que será necesaria para los cálculos.
    this.lot_progress_list.forEach((elem, ind) => {
		
		let previus_elem = null;
		
		if (ind === 0) {
			elem['uds'] = Number(elem.unidades_acumuladas);
			elem['mat'] = elem.materiales;
			
		} else {
			
			if (this.lot_progress_list[ind - 1]) previus_elem = this.lot_progress_list[ind - 1];
			
			if (previus_elem) {
				elem['uds'] = Number(elem.unidades_acumuladas) - Number(previus_elem.unidades_acumuladas);
				elem['mat'] = elem.materiales - previus_elem.materiales;
			}
		}
		
		elem['porcent'] = (100 * elem['uds']) / total_uds;
		elem['enum_seq'] = elem.seq_fin - elem.seq_inicio;
	});
    /*
    // Modo de ordenación por "tanto porciento progresado".
    this.sequence_list_ordered.forEach(elem_mat => {
		
		// Se buscan elementos donde puedan estar contenidos su
		// secuencia de inicio o su secuencia fin (quiere decir
		// que ese material interviene dentro de ese elemento).
		// Pueden salir más de un resultado si el material se
		// usa en más de un elemento (producto ventana).
		let find_elem = this.lot_progress_list.filter(elem_prog => 
				(elem_mat.max_seq >= elem_prog.seq_inicio && elem_mat.max_seq <= elem_prog.seq_fin) || 
				(elem_mat.min_seq >= elem_prog.seq_inicio && elem_mat.min_seq <= elem_prog.seq_fin)
		);
		
		if (find_elem && find_elem.length > 0) {
			// console.log('Encontrados elementos en progreso:' + find_elem.length);
			// console.log(find_elem);
			
			let selected_item = null;
			
			find_elem.forEach((elem_in, ind_elem_in) => {
				
				// if (selected_item.porcent > elem_in.porcent && !elem_in['check']) {
				if (!elem_in['check']) {
					
					elem_in['check'] = true;
					
					selected_item = elem_in;
					
					// console.log('Cambiando selected_item:');
					// console.log(selected_item);
					
					if (selected_item) {
				
						// Sólo se añade si ese material no existía ya en la lista.
						let exit_elem = this.lot_progress_list_ordered.find(elem_res => elem_res.nuevos_materiales === selected_item.nuevos_materiales);
						
						if(!exit_elem) this.lot_progress_list_ordered.push(JSON.parse(JSON.stringify(selected_item)));	
					}
					
				} else {
					console.log('Este elemento ya fue seleccionado:');
					// console.log(elem_in);
				}
			}); // End Foreach find_elem.
		} else {
			console.log('No encontrado elementos en progreso:');
			console.log(elem_mat);
		}
	});
	
	// Se recalculan las unidades y porcentajes acumulados
	// siguiendo este nuevo orden de aparición.
	
	let total_uds_aux = 0;
	let total_porcent_aux = 0;
	let total_mat = 0;
	let count_seq = 0;

	this.lot_progress_list_ordered.forEach(elem => {
		
		total_uds_aux += elem['uds'];
		total_porcent_aux += elem['porcent'];
		total_mat += elem['mat'];
		
		count_seq++;
		
		elem['min_seq'] = count_seq;
		
		count_seq += elem['enum_seq'];
		
		elem['max_seq'] = count_seq;
		
		elem.unidades_acumuladas = total_uds_aux;
		elem.porcentaje_acumulado = total_porcent_aux.toFixed(2);
		elem.materiales = total_mat;
	}); // */
	
	// ----- Fin Modo "tanto porciento progresado".
	
		this.lot_progress_list_ordered = lotStudyIn.lot_progress_list_tmp;
		this.enrichProgressTimeInMinutes(this.lot_progress_list_ordered);
	
	// Se calculan las unidades totales de la nueva ordenación.
	let total_uds_tmp = 0;
    
    if (this.lot_progress_list_ordered.length) {
    	total_uds_tmp = this.lot_progress_list_ordered[this.lot_progress_list_ordered.length - 1].unidades_acumuladas;
    }
    
    console.log('--> total_uds_tmp:');
    console.log(total_uds_tmp);
	
	// Añadimos información extra de "unidades" y "porcentaje" que será necesaria para los cálculos.
    this.lot_progress_list_ordered.forEach((elem, ind) => {
		
		let previus_elem = null;
		
		if (ind === 0) {
			elem['uds'] = Number(elem.unidades_acumuladas);
			elem['mat'] = elem.materiales;
			
		} else {
			
			if (this.lot_progress_list_ordered[ind - 1]) previus_elem = this.lot_progress_list_ordered[ind - 1];
			
			if (previus_elem) {
				elem['uds'] = Number(elem.unidades_acumuladas) - Number(previus_elem.unidades_acumuladas);
				elem['mat'] = elem.materiales - previus_elem.materiales;
			}
		}
		
		elem['porcent'] = (100 * elem['uds']) / total_uds_tmp;
		elem['enum_seq'] = elem.seq_fin - elem.seq_inicio;
	});
    
    console.log('--> lot_progress_list_ordered:');
    // console.log(this.lot_progress_list_ordered);

    if (this.lot_progress_list.length === 0 && this.lot_progress_list_ordered.length === 0) {
      this.lotStudyWarning = 'No hay datos de progreso para el lote ' + lotStudyIn.lot + '. Revisa que la vista de progreso esté actualizada.';
    } else {
      this.lotStudyWarning = '';
    }
    
    this.button_study_pressed = false;
	
	  } // End function showLotStudy.

  private enrichProgressTimeInMinutes(progressListIn: any[]) {
    if (!progressListIn || progressListIn.length < 1) {
      return;
    }

    let prevAccumMin = 0;
    progressListIn.forEach((elem, ind) => {
      const providedFabMin = Number(elem && elem['tiempo_fab_min'] !== undefined ? elem['tiempo_fab_min'] : NaN);
      const providedCutMin = Number(elem && elem['tiempo_corte_min'] !== undefined ? elem['tiempo_corte_min'] : NaN);
      if (Number.isFinite(providedFabMin) && Number.isFinite(providedCutMin) && providedFabMin >= 0 && providedCutMin >= 0) {
        elem['tiempo_fab_min'] = Math.round(providedFabMin * 100) / 100;
        elem['tiempo_corte_min'] = Math.round(providedCutMin * 100) / 100;
        prevAccumMin = elem['tiempo_fab_min'];
        return;
      }

      const hoursAccum = Number(elem && elem['tiempo_h'] !== undefined ? elem['tiempo_h'] : 0);
      const accumMinRaw = Number.isFinite(hoursAccum) ? (hoursAccum * 60) : 0;
      const accumMin = Math.round(accumMinRaw * 100) / 100;
      const cutMinRaw = ind === 0 ? accumMin : (accumMin - prevAccumMin);
      const cutMin = Math.round(Math.max(0, cutMinRaw) * 100) / 100;

      elem['tiempo_fab_min'] = accumMin;
      elem['tiempo_corte_min'] = cutMin;
      prevAccumMin = accumMin;
    });
  }

  hasApproxWarning(progressListIn: any[]): boolean {
    if (!progressListIn || progressListIn.length < 1) {
      return false;
    }
    return progressListIn.some((item) => item && item['material_no_optimized'] === true);
  }

  getCutTimeComposition(itemIn: any): string {
    const kgMin = Number(itemIn && itemIn['tiempo_corte_kg_min'] !== undefined ? itemIn['tiempo_corte_kg_min'] : 0);
    const sheetMin = Number(itemIn && itemIn['tiempo_corte_hojas_min'] !== undefined ? itemIn['tiempo_corte_hojas_min'] : 0);
    const kgTxt = (Number.isFinite(kgMin) ? kgMin : 0).toFixed(2);
    const sheetTxt = (Number.isFinite(sheetMin) ? sheetMin : 0).toFixed(2);
    return kgTxt + ' + ' + sheetTxt;
  }

  getCutTimeAccumulated(progressListIn: any[], indexIn: number): number {
    if (!progressListIn || progressListIn.length < 1 || indexIn < 0) {
      return 0;
    }

    let total = 0;
    const maxIndex = Math.min(indexIn, progressListIn.length - 1);
    for (let i = 0; i <= maxIndex; i++) {
      const value = Number(progressListIn[i] && progressListIn[i]['tiempo_corte_min'] !== undefined
        ? progressListIn[i]['tiempo_corte_min']
        : 0);
      if (Number.isFinite(value) && value > 0) {
        total += value;
      }
    }

    return Math.round(total * 100) / 100;
  }
  
  // Función que manda los datos necesarios para imprimir el informe de la compactación.
  printDivideLotInfo(divideLotIn, useTmpIn: boolean = false, compactAssocModeIn: string = 'no') {
	
	console.log('--> printDivideLotInfo:');
    console.log(divideLotIn);
    
    // NOTA: para usar la función de impresión en PDF.
    this.printDivideLot.emit({
      lot_info: divideLotIn,
      print_mode: this.print_mode,
      print_use_tmp: useTmpIn === true,
      compact_assoc_mode: compactAssocModeIn ? compactAssocModeIn.toString() : 'no',
      easel_id: this.print_mode === 'route_dispatch' ? this.selected_dispatch_easel_id : null,
      action: 'PrintDivideLot',
      back: 'file-list'
    });
	
  } // End function printDivideLotInfo.

  printRouteExpeditionInfo(lotListIn: Array<number | string>, useTmpIn: boolean = false) {
    const lotList = (lotListIn || [])
      .map((lot) => Number(lot))
      .filter((lot, index, self) => Number.isFinite(lot) && lot > 0 && self.indexOf(lot) === index);

    if (lotList.length < 1) {
      return;
    }

    this.printDivideLot.emit({
      action: 'PrintRouteExpedition',
      back: 'file-list',
      print_mode: this.print_mode,
      print_use_tmp: useTmpIn === true,
      source_table: (useTmpIn === true && lotList.length === 1) ? 'order_planned_tmp' : 'order_planned',
      batchno_list: lotList,
      easel_id: this.selected_dispatch_easel_id
    });
  }

  printProfilesInfo(lotListIn: Array<number | string>, useTmpIn: boolean = false) {
    const lotList = (lotListIn || [])
      .map((lot) => Number(lot))
      .filter((lot, index, self) => Number.isFinite(lot) && lot > 0 && self.indexOf(lot) === index);

    if (lotList.length < 1) {
      return;
    }

    this.printDivideLot.emit({
      action: 'PrintAutoOptiProfiles',
      back: 'opti-prod',
      print_use_tmp: useTmpIn === true,
      source_table: (useTmpIn === true && lotList.length === 1) ? 'order_planned_tmp' : 'order_planned',
      profiles_info: {
        lot_list: lotList,
        lots: lotList.join(','),
        generated_at: new Date().toISOString(),
        generated_at_display: this.formatDateTimeHuman(new Date()),
        user_name: this.current_username ? this.current_username.toString() : '',
        include_grouped_profiles: this.print_include_grouped_profiles
      }
    });
  }

  printBendingMachineCnc(lotListIn: Array<number | string>, useTmpIn: boolean = false) {
    const lotList = (lotListIn || [])
      .map((lot) => Number(lot))
      .filter((lot, index, self) => Number.isFinite(lot) && lot > 0 && self.indexOf(lot) === index);

    if (lotList.length < 1) {
      return;
    }

    if (!this.bendingMachineList || this.bendingMachineList.length < 1) {
      this.showInfoModal.emit({
        value: true,
        info: 'No existe plegadora disponible para poder generar este fichero. Revise Maestros > Plegadoras.',
        link: '',
        skin: 'alert'
      });
      return;
    }

    const machineId = Number(this.selected_bending_machine_id);
    if (!Number.isFinite(machineId) || machineId < 1) {
      this.showInfoModal.emit({
        value: true,
        info: 'Debe seleccionar una plegadora para generar el CNC.',
        link: '',
        skin: 'alert'
      });
      return;
    }

    const selectedMachine = this.bendingMachineList.find(item => Number(item && item.id) === machineId);
    const stdDiscount = Number(selectedMachine && selectedMachine.std_profile_discount);
    if (!Number.isFinite(stdDiscount) || stdDiscount <= 0) {
      this.showInfoModal.emit({
        value: true,
        info: 'La plegadora seleccionada tiene "descuento perfil estandar" a cero. Revíselo en maestros.',
        link: '',
        skin: 'alert'
      });
      return;
    }

    this.executeBendingMachineCnc(lotList, machineId, useTmpIn === true, null, false);
  }

  private executeBendingMachineCnc(
    lotListIn: number[],
    machineIdIn: number,
    useTmpIn: boolean,
    manualCodesIn: any[] | null,
    applyManualCodesIn: boolean
  ) {
    const payload: any = {
      action: 'CreateBendingCNC',
      back: 'opti-prod',
      print_use_tmp: useTmpIn === true,
      source_table: (useTmpIn === true && lotListIn.length === 1) ? 'order_planned_tmp' : 'order_planned',
      bending_info: {
        lot_list: lotListIn,
        lots: lotListIn.join(','),
        machine_id: machineIdIn
      }
    };

    if (manualCodesIn && manualCodesIn.length > 0) {
      payload.bending_info.manual_codes = manualCodesIn;
      payload.bending_info.apply_manual_codes = applyManualCodesIn === true;
    }

    this.changingLoading.emit(true);
    this.fileService.printEasels(payload).subscribe(
      (response: any) => {
        this.changingLoading.emit(false);
        if (response && response.manual_required === true) {
          this.openBendingCodesModal(response, lotListIn, useTmpIn, machineIdIn);
          return;
        }
        if (response && response.content && response.file_name) {
          this.closeBendingCodesModal();
          this.downloadBendingFile(response.content, response.file_name);
          this.showInfoModal.emit({
            value: true,
            info: 'Se ha realizado la acción correctamente.',
            link: '',
            skin: 'info'
          });
          return;
        }
        this.showInfoModal.emit({
          value: true,
          info: 'No se ha podido generar el CNC de plegadora.',
          link: '',
          skin: 'alert'
        });
      },
      (error: any) => {
        this.changingLoading.emit(false);
        const errPayload = error && error.error ? error.error : null;
        if (errPayload && errPayload.code && errPayload.code.toString() === 'BENDING_CODES_MISSING') {
          this.openBendingCodesModal(errPayload, lotListIn, useTmpIn, machineIdIn);
          return;
        }
        let errorText = '';
        if (errPayload) {
          if (typeof errPayload === 'string') {
            errorText = errPayload;
          } else {
            errorText = errPayload.error || errPayload.message || '';
          }
        }
        if (!errorText) {
          errorText = 'Error al generar el CNC de plegadora.';
        }
        this.showInfoModal.emit({
          value: true,
          info: errorText,
          link: '',
          skin: 'alert'
        });
      }
    );
  }

  private openBendingCodesModal(errPayloadIn: any, lotListIn: number[], useTmpIn: boolean, machineIdIn: number) {
    const missing = errPayloadIn && Array.isArray(errPayloadIn.missing_profiles)
      ? errPayloadIn.missing_profiles
      : [];
    this.bendingCodesMissingRows = missing.map((item: any) => ({
      profile_key: item && item.profile_key ? item.profile_key.toString() : '',
      profile_label: item && item.profile_label ? item.profile_label.toString() : '-',
      slots: item && item.slots ? item.slots.toString() : '',
      code: ''
    }));
    this.bendingCodesLotList = (lotListIn || []).map(item => Number(item)).filter(item => Number.isFinite(item) && item > 0);
    this.bendingCodesUseTmp = useTmpIn === true;
    this.selected_bending_machine_id = Number(machineIdIn);
    this.bendingCodesModal = this.bendingCodesMissingRows.length > 0;
  }

  closeBendingCodesModal() {
    this.bendingCodesModal = false;
    this.bendingCodesMissingRows = [];
    this.bendingCodesLotList = [];
    this.bendingCodesUseTmp = false;
  }

  confirmBendingCodesModal() {
    const regexCode = /^[0-9A-Za-z]+$/;
    const manualCodes = [];
    for (let i = 0; i < this.bendingCodesMissingRows.length; i++) {
      const row = this.bendingCodesMissingRows[i];
      const codeRaw = row && row.code !== undefined && row.code !== null ? row.code.toString().trim() : '';
      if (codeRaw === '' || !regexCode.test(codeRaw)) {
        this.showInfoModal.emit({
          value: true,
          info: 'Revise los códigos Lombarda. Solo se permiten letras y números.',
          link: '',
          skin: 'alert'
        });
        return;
      }
      manualCodes.push({
        profile_key: row.profile_key,
        profile: row.profile_label,
        code: codeRaw.toUpperCase()
      });
    }

    const machineId = Number(this.selected_bending_machine_id);
    if (!Number.isFinite(machineId) || machineId < 1 || this.bendingCodesLotList.length < 1) {
      this.showInfoModal.emit({
        value: true,
        info: 'No se pudo recuperar el contexto para generar el CNC de plegadora.',
        link: '',
        skin: 'alert'
      });
      return;
    }

    const doRepair = window.confirm('Se van a guardar estos códigos en ORDER_PLANNED.info_add para futuras descargas. ¿Desea continuar?');
    this.executeBendingMachineCnc(this.bendingCodesLotList, machineId, this.bendingCodesUseTmp, manualCodes, doRepair === true);
  }

  private downloadBendingFile(contentIn: string, fileNameIn: string) {
    const blob = new Blob([contentIn], { type: 'application/octet-stream' });
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = fileNameIn ? fileNameIn.toString() : 'bending.job';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
  }

  printCurrentLotInfo(useTmpIn: boolean = false) {
    if (!this.current_lot) {
      return;
    }

    if (this.print_mode === 'profiles') {
      this.printProfilesInfo([this.current_lot], useTmpIn);
      return;
    }

    if (this.print_mode === 'bending_cnc') {
      this.printBendingMachineCnc([this.current_lot], useTmpIn);
      return;
    }

    if (this.print_mode === 'route_dispatch') {
      this.printRouteExpeditionInfo([this.current_lot], useTmpIn);
      return;
    }

    if (this.print_mode === 'compact' || this.print_mode === 'compact_hybrid' || this.print_mode === 'compact_hybrid_plus') {
      this.requestCompactPileByLots([this.current_lot]);
      return;
    }

    this.prepareDivideLotPrint({
      lot_0: this.current_lot,
      lot_1: this.current_lot,
      lot_2: null
    }, useTmpIn);
  }

  printLastDividedLotsInfo() {
    if (this.print_mode === 'profiles') {
      if (!this.last_divide_info || !this.last_divide_info.lot_1 || !this.last_divide_info.lot_2) {
        if (this.current_lot) {
          this.printProfilesInfo([this.current_lot], true);
        }
        return;
      }
      this.printProfilesInfo([this.last_divide_info.lot_1, this.last_divide_info.lot_2]);
      return;
    }

    if (this.print_mode === 'bending_cnc') {
      if (!this.last_divide_info || !this.last_divide_info.lot_1 || !this.last_divide_info.lot_2) {
        if (this.current_lot) {
          this.printBendingMachineCnc([this.current_lot], true);
        }
        return;
      }
      this.printBendingMachineCnc([this.last_divide_info.lot_1, this.last_divide_info.lot_2]);
      return;
    }

    if (this.print_mode === 'route_dispatch') {
      if (!this.last_divide_info || !this.last_divide_info.lot_1 || !this.last_divide_info.lot_2) {
        if (this.current_lot) {
          this.printRouteExpeditionInfo([this.current_lot], true);
        }
        return;
      }

      this.printRouteExpeditionInfo([this.last_divide_info.lot_1, this.last_divide_info.lot_2]);
      return;
    }

    if (this.print_mode === 'compact' || this.print_mode === 'compact_hybrid' || this.print_mode === 'compact_hybrid_plus') {
      if (!this.last_divide_info || !this.last_divide_info.lot_1 || !this.last_divide_info.lot_2) {
        if (this.current_lot) {
          this.requestCompactPileByLots([this.current_lot]);
        }
        return;
      }

      this.requestCompactPileByLots([this.last_divide_info.lot_1, this.last_divide_info.lot_2]);
      return;
    }

    // Si no hay división previa, se imprime el lote actual (mismo comportamiento que tabla 1).
    if (!this.last_divide_info || !this.last_divide_info.lot_1 || !this.last_divide_info.lot_2) {
      // En la tabla 2 sin división previa se debe imprimir con el orden sugerido (tabla temporal).
      this.printCurrentLotInfo(true);
      return;
    }

    this.prepareDivideLotPrint({
      lot_0: this.last_divide_info.lot_0,
      lot_1: this.last_divide_info.lot_1,
      lot_2: this.last_divide_info.lot_2
    });
  }

  getLastDivideLabel(lotNumber: number, initSeq: number, endSeq: number): string {
    if (!lotNumber || initSeq === null || initSeq === undefined || endSeq === null || endSeq === undefined) {
      return '';
    }

    return lotNumber + ' (' + initSeq + ':' + endSeq + ')';
  }

  prepareDivideLotPrint(divideLotIn: any, useTmpIn: boolean = false) {
    if (!divideLotIn) {
      return;
    }

    const isProdMode = (this.print_mode === 'basic' || this.print_mode === 'extended');
    if (!isProdMode) {
      this.printDivideLotInfo(divideLotIn, useTmpIn, 'no');
      return;
    }

    const lotForAssoc = Number(divideLotIn && divideLotIn.lot_1 !== undefined && divideLotIn.lot_1 !== null
      ? divideLotIn.lot_1
      : this.current_lot);
    if (!Number.isFinite(lotForAssoc) || lotForAssoc < 1) {
      this.printDivideLotInfo(divideLotIn, useTmpIn, 'no');
      return;
    }

    this.pendingPrintInfo = divideLotIn;
    this.pendingPrintUseTmp = useTmpIn === true;
    this.compactAssocLot = lotForAssoc;
    this.compactAssocMode = 'no';
    this.compactAssocOptions = this.getCompactAssocModeOptions([]);
    this.compactAssocLoading = true;
    this.compactAssocModal = true;

    this.fileService.printEasels({
      action: 'GetCompactAssociationInfo',
      back: 'opti-prod',
      lot: lotForAssoc
    }).subscribe(
      (response: any) => {
        const latestMode = response && response.latest_mode_code ? response.latest_mode_code.toString() : 'no';
        const availableModes = response && Array.isArray(response.available_modes)
          ? response.available_modes.map((item: any) => item && item.code ? item.code.toString() : '')
          : [];
        this.compactAssocOptions = this.getCompactAssocModeOptions(availableModes);
        const allowed = this.compactAssocOptions.map(item => item.value);
        this.compactAssocMode = allowed.includes(latestMode) ? latestMode : 'no';
        this.compactAssocLoading = false;
      },
      () => {
        this.compactAssocMode = 'no';
        this.compactAssocOptions = this.getCompactAssocModeOptions([]);
        this.compactAssocLoading = false;
      }
    );
  }

  confirmCompactAssocModal() {
    const payload = this.pendingPrintInfo ? this.pendingPrintInfo : null;
    const useTmp = this.pendingPrintUseTmp === true;
    const mode = this.compactAssocMode ? this.compactAssocMode.toString() : 'no';
    this.closeCompactAssocModal();
    if (payload) {
      this.printDivideLotInfo(payload, useTmp, mode);
    }
  }

  closeCompactAssocModal() {
    this.compactAssocModal = false;
    this.compactAssocLoading = false;
    this.pendingPrintInfo = null;
    this.pendingPrintUseTmp = false;
    this.compactAssocLot = null;
    this.compactAssocMode = 'no';
    this.compactAssocOptions = [];
  }

  getCompactAssocModeOptions(availableModesIn: string[] = []): any[] {
    const allOptions = [
      { value: 'no', label: 'NO' },
      { value: 'classic', label: 'ESTANDAR' },
      { value: 'hybrid_family', label: 'HIBRIDA' },
      { value: 'hybrid_family_plus', label: 'HIBRIDA PLUS' }
    ];

    const availableModes = (availableModesIn || [])
      .map(item => item ? item.toString().trim() : '')
      .filter(item => item !== '' && item !== 'no');

    if (availableModes.length < 1) {
      return [allOptions[0]];
    }

    return allOptions.filter((item, index) => index === 0 || availableModes.includes(item.value));
  }

  onPrintModeChange() {
    if (this.print_mode === 'route_dispatch' || this.print_mode === 'compact' || this.print_mode === 'compact_hybrid' || this.print_mode === 'compact_hybrid_plus') {
      this.reloadEaselList.emit();
    }

    const preferredEaselId = this.getPreferredEaselId(this.easelList);
    if (this.print_mode === 'route_dispatch' && (this.selected_dispatch_easel_id === null || this.selected_dispatch_easel_id === undefined)) {
      this.selected_dispatch_easel_id = preferredEaselId;
    }
    if ((this.print_mode === 'compact' || this.print_mode === 'compact_hybrid' || this.print_mode === 'compact_hybrid_plus') &&
        (this.selected_compact_easel_id === null || this.selected_compact_easel_id === undefined)) {
      this.selected_compact_easel_id = preferredEaselId;
    }
  }

  private loadBendingMachines() {
    this.bendingMachineService.getBendingMachines({}).subscribe(
      (response: any[]) => {
        this.bendingMachineList = response && response.length
          ? response.filter(item => this.isMachineActive(item))
          : [];
        if (this.bendingMachineList.length > 0 && (!this.selected_bending_machine_id || this.selected_bending_machine_id < 1)) {
          this.selected_bending_machine_id = Number(this.bendingMachineList[0].id);
        }
      },
      () => {
        this.bendingMachineList = [];
      }
    );
  }

  private isMachineActive(itemIn: any): boolean {
    if (!itemIn) {
      return false;
    }
    const activeRaw = itemIn.active;
    if (activeRaw === true) {
      return true;
    }
    if (activeRaw === false || activeRaw === null || activeRaw === undefined) {
      return false;
    }
    const num = Number(activeRaw);
    return Number.isFinite(num) ? num === 1 : (activeRaw.toString().toLowerCase() === 'true');
  }

  requestCompactPileByLots(lotListIn: Array<number | string>) {
    if (this.selected_compact_easel_id === null || this.selected_compact_easel_id === undefined) {
      this.showInfoModal.emit({
        value: true,
        info: 'Debe seleccionar un caballete para imprimir la vista 2D de compactación.',
        link: '',
        skin: 'alert'
      });
      return;
    }

    if (!lotListIn || lotListIn.length === 0) {
      return;
    }

    const lotList = lotListIn
      .map((lot) => Number(lot))
      .filter((lot, index, self) => !!lot && self.indexOf(lot) === index);

    if (lotList.length === 0) {
      return;
    }

    this.pending_compact_lots = lotList;
    this.button_virtual_pressed = true;
    this.requestNextCompactLot();
  }

  requestNextCompactLot() {
    if (!this.pending_compact_lots || this.pending_compact_lots.length === 0) {
      this.button_virtual_pressed = false;
      this.current_compact_lot = null;
      return;
    }

    const nextLot = this.pending_compact_lots.shift();
    if (!nextLot) {
      this.requestNextCompactLot();
      return;
    }

    this.current_compact_lot = Number(nextLot);
    let compactMode = 'classic';
    if (this.print_mode === 'compact_hybrid') {
      compactMode = 'hybrid_family';
    } else if (this.print_mode === 'compact_hybrid_plus') {
      compactMode = 'hybrid_family_plus';
    }
    this.compactOpti.emit({
      opti_lot: nextLot.toString(),
      exact_lot: true,
      compact_mode: compactMode
    });
  }

  // Función que manda los datos necesarios para imprimir el informe de la compactación.
  printCompactPile(compactPileIn) {
    this.printCompactOpti.emit({
      compact_list_info: compactPileIn,
      easel_id: this.selected_compact_easel_id,
      action: 'PrintCompactPile',
      back: 'file-list'
    });
  }

  getSortedEaselList(): Easel[] {
    if (!this.easelList || this.easelList.length === 0) {
      return [];
    }

    return this.easelList.slice().sort((a, b) => {
      const pa = Number(a && a.priority !== undefined && a.priority !== null ? a.priority : 999);
      const pb = Number(b && b.priority !== undefined && b.priority !== null ? b.priority : 999);
      if (pa !== pb) {
        return pb - pa;
      }
      const ia = Number(a && a.id !== undefined && a.id !== null ? a.id : 0);
      const ib = Number(b && b.id !== undefined && b.id !== null ? b.id : 0);
      return ia - ib;
    });
  }

  private getPreferredEaselId(easelListIn: Easel[]): number {
    const sorted = easelListIn && easelListIn.length > 0 ? easelListIn.slice().sort((a, b) => {
      const pa = Number(a && a.priority !== undefined && a.priority !== null ? a.priority : 999);
      const pb = Number(b && b.priority !== undefined && b.priority !== null ? b.priority : 999);
      if (pa !== pb) {
        return pb - pa;
      }
      const ia = Number(a && a.id !== undefined && a.id !== null ? a.id : 0);
      const ib = Number(b && b.id !== undefined && b.id !== null ? b.id : 0);
      return ia - ib;
    }) : [];

    if (!sorted || sorted.length < 1) {
      return null;
    }

    return Number(sorted[0].id);
  }

  private formatDateTimeHuman(valueIn: Date): string {
    const dateAux = valueIn instanceof Date ? valueIn : new Date(valueIn);
    if (isNaN(dateAux.getTime())) {
      return '';
    }

    const day = dateAux.getDate().toString().padStart(2, '0');
    const month = (dateAux.getMonth() + 1).toString().padStart(2, '0');
    const year = dateAux.getFullYear().toString();
    const hour = dateAux.getHours().toString().padStart(2, '0');
    const minute = dateAux.getMinutes().toString().padStart(2, '0');
    return day + '/' + month + '/' + year + ' ' + hour + ':' + minute;
  }

} // End class OptiProdComponent
